export const meta = {
  title: '使用条款',
  description: '独立玩家攻略与配装工具的使用说明。',
  updated_at: '2026-10-08',
};

## 独立玩家站点

本站与 Remedy Entertainment 或游戏权利人没有隶属关系。游戏名称、商标等属于各自权利人。

## 攻略与建议

攻略基于已发布资料核验，技能建议属于编辑判断。版本更新可能改变游戏行为，请结合来源与核验日期阅读。

## 配装工具

工具只记录选择，不修改游戏存档、不计算经实测的伤害，也不保证游戏结果。浏览器数据可能被删除，请自行保留重要链接。

## 原创素材与第三方权利

站点标识与谜题示意图为原创玩家站素材。外部链接内容仍属于其权利人；本站不复制竞争站截图或歌词。

## 可用性

服务按当前可用状态提供，功能与内容可能调整。

## 联系与隐私

问题请发送至 [support@controlresonanttools.online](mailto:support@controlresonanttools.online)。数据处理详见[隐私政策](/privacy-policy)。
